export const ParticipantsAmount = {
	ONE:  'one',
	TWO:  'two',
	MANY: 'many',
};
